import { render, staticRenderFns } from "./ClientAccountingList.vue?vue&type=template&id=94b0b118&"
import script from "./ClientAccountingList.vue?vue&type=script&lang=js&"
export * from "./ClientAccountingList.vue?vue&type=script&lang=js&"
import style0 from "./ClientAccountingList.vue?vue&type=style&index=0&id=94b0b118&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports